<template>
  <div>
    <div class="nav-title">
      Login/out
    </div>
    <div class="mt-1 px-2 flex flex-col gap-2">
      <div class="flex flex-col gap-2">
        <div
          class="item"
        >
          <span class="bg-dark-3 px-1 h-10 w-10 flex items-center justify-center">{{ `Lv.${authStore.user.level_info.level}` }}</span>
          <span class="truncate">{{ authStore.user.nickname }}</span>
        </div>
        <div
          class="item"
        >
          <div class="bg-dark-3 px-1 h-10 w-10 flex items-center justify-center">
            <SvgIcon
              name="wallet"
              size="xs"
            />
          </div>
          <span class="truncate">{{ authStore.walletBalance }}</span>
        </div>
        <div
          class="item"
        >
          <div class="bg-dark-3 px-1 h-10 w-10 flex items-center justify-center">
            <SvgIcon
              name="point"
              size="xs"
            />
          </div>

          <span class="truncate">{{ authStore.pointBalance }}</span>
        </div>
        <div
          class="item"
        >
          <div class="bg-dark-3 px-1 h-10 w-10 flex items-center justify-center">
            <SvgIcon
              name="gold"
              size="xs"
            />
          </div>
          <span class="truncate">{{ authStore.coinBalance }}</span>
        </div>
      </div>
      <QBtn
        dense
        unelevated
        class="w-full h-10 !bg-dark-3 border border-solid border-dark-4"
        @click="logout"
      >
        Logout
      </QBtn>
    </div>
  </div>
</template>
<script setup>
import SvgIcon from '@/components/Icons/SvgIcon.vue'
import { useAuthStore } from '@/stores/auth.js'
import {useConfigStore} from '@/stores/config'

const authStore = useAuthStore()
const configStore = useConfigStore()

async function logout(){
  await authStore.logout()
  await configStore.toggleRightDrawer()
}
</script>
<style scoped>
.item {
  @apply flex items-center gap-2 rounded overflow-hidden dark:bg-dark-2 light:bg-light-2 border border-dark-3 h-10
}
</style>
